import { Outlet } from 'react-router-dom';

function CartRootLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default CartRootLayout;
